/**
 * @file
 * Provide several d3 charts visualizations.
 *
 * Mainly use the following submodules of d3-js:
 *
 * - d3-selection (https://github.com/d3/d3-selection)
 * Used for dom-manipulation and generate the needed markup.
 *
 * - d3-fetch (https://github.com/d3/d3-fetch)
 * Used to load the JSON-Data.
 *
 * - d3-shape (https://github.com/d3/d3-shape)
 * Used to generate complex geometrical shapes like arcs, lines and annular areas.
 *
 * - d3-path (https://github.com/d3/d3-path)
 * Used to generate complex geometrical lines.
 */

let color_gray        = '#A6A6A6',
    color_gray_light  = '#E2E2E2',
    color_red         = '#cc6c5b',
    color_green       = '#9fd773';

let pollChartsData    = '';

/**
 * Attaches the D3 poll charts behavior.
 *
 * @type {Drupal~behavior}
 *
 * @prop {Drupal~attachBehavior}
 */

(function ($, Drupal) {
  Drupal.behaviors.d3PollCharts = {
    attach: function attach(context) {
      once('d3PollChartsData', '.js-d3-poll-charts', context).forEach(function(currentElement) {
        let element = $(currentElement);
        let wrapper = element[0];
        $.getJSON(wrapper.dataset.url).done(function( data ) {

          /**
           * Horizontal poll charts.
           *
           * Applies to elements with the css-class: '.js-d3-bar-horizontal-stacked'.
           * The chart can be configured by following data-attributes:
           * - [data-url]: The JSON-Data which contains the voting behavior
           * - [data-label-total-before]: Define the content before the total count of persons who voted (e.g. Poll result)
           * - [data-label-total-after]: Define the content after the total count of persons who voted (e.g. Members, Candidates)
           *
           * e.g.: <span class="js-d3-bar-horizontal-stacked" data-url="path-to-json/inline-json" data-label-total-before="Poll result"
           * data-label-total-after="Members">
           *
           */

          $(context).find('.js-d3-bar-horizontal-stacked').each(function() {

            let element = $(this);
            let wrapper = element[0];
            let barWrapper = d3.select(wrapper)
              .append('div')
              .attr('class', 'd3-bars');

            let totalPollCount = data.count;
            let totalLabelBefore = wrapper.dataset.labelTotalBefore;
            let totalLabelAfter = wrapper.dataset.labelTotalAfter;
            let votingKeys = Object.keys(data.count_by_voting);
            let votingValues = Object.values(data.count_by_voting);
            let pollTableUrl = data.poll_table_url;

            barWrapper.selectAll('div')
              .data(votingValues)
              .enter()
              .append('a')
              .attr('class', 'd3-bars__item')
              .style('width', function(d) {
                let value = 100 / totalPollCount * d;
                return value + '%';
              })
              .data(votingKeys)
              .attr('href', function (d) {
                return pollTableUrl + '?vote['+ d +']=' + d;
              })
              .style('background-color', function (d) {
                return Drupal.chartColorsByVote(d);
              });

            // Define Total-Label
            let totalLabelWrapper = d3.select(wrapper)
              .append('p')
              .attr('class', 'd3__total-label')
              .html(function (d) {
                return totalLabelBefore + ' ' + totalPollCount + ' ' + totalLabelAfter;
              });

            // Define Labels
            let labelWrapper = d3.select(wrapper)
              .append('ul')
              .attr('class', 'd3__label d3__label--inline');

            let labelItem = labelWrapper.selectAll('li')
              .data(votingKeys)
              .enter()
              .append('li')
              .attr('class', 'd3__label__item')
              .append('a')
              .attr('href', function (d) {
                return pollTableUrl + '?vote['+ d +']=' + d;
              })
              .append('span')
              .attr('class', 'd3__label__item__indicator')
              .style('background-color', function (d) {
                return Drupal.chartColorsByVote(d);
              })
              .select(function() { return this.parentNode; })
              .append('span')
              .data(votingValues)
              .html(function (d) {
                return d + ' ';
              })
              .select(function() { return this.parentNode; })
              .append('span')
              .data(votingKeys)
              .html(function (d) {
                return Drupal.voteBehaviorLabel(d);
              });
          });

          /**
           * Vertical poll charts.
           *
           * Applies to elements with the css-class: '.js-d3-bar-vertical-stacked-poll'.
           * The chart can be configured by following data-attributes:
           * - [data-url]: The JSON-Data which contains the voting behavior
           *
           * e.g.: <span class="js-d3-bar-vertical-stacked-poll" data-url="path-to-json/inline-json">
           *
           */

          $(context).find('.js-d3-bar-vertical-stacked-poll').each(function() {
            let wrapper = $(this)[0];
            let countByFraction = data.count_by_fraction;
            let countByFractionVoting = data.count_by_fraction_voting;
            let fractions = data.fractions;
            let pollTableUrl = data.poll_table_url;
            let countByFractionVotingArray = [];

            // Convert object to array
            for(count in countByFractionVoting){
              countByFractionVotingArray.push([count,countByFractionVoting[count]])
            }
            // Add descending order for the array by votes
            countByFractionVotingArray.sort(function(a,b) {
              let totalA = a[1].yes + a[1].no + a[1].abstain + a[1].no_show;
              let totalB = b[1].yes + b[1].no + b[1].abstain + b[1].no_show;

              return totalB - totalA;
            });

            for (let key in countByFractionVotingArray) {

              // Define chart-wrapper for all parties

              let chartwrapper = d3.select(wrapper)
                .append('div')
                .attr('class', 'd3-chart');

              // Define bar-charts
              let fractionID = countByFractionVotingArray[key][0];
              let votingKeys = Object.keys(countByFractionVotingArray[key][1]);
              let votingValues = Object.values(countByFractionVotingArray[key][1]);

              let barWrapper = chartwrapper
                .append('div')
                .attr('class', 'd3-bars')
                .selectAll('div')
                .data(votingValues)
                .enter()
                .append('a')
                .attr('class', 'd3-bars__item')
                .style('height', function(d) {
                  let value = 100 / countByFraction[fractionID] * d;
                  return value + '%';
                })
                .data(votingKeys)
                .style('background-color', function (d) {
                  return Drupal.chartColorsByVote(d);
                })
                .attr('href', function (d) {
                  return pollTableUrl + '?fraction='+ fractionID + '&vote['+ d +']=' + d;
                });

              // Define labels
              let labelWrapper = chartwrapper
                .append('div')
                .attr('class', 'd3__label_outer')
                .html('<h3 class="d3__title">' + fractions[fractionID] + ' <span class="d3__title__indicator">' + Drupal.formatPlural(countByFraction[fractionID], '1 deputy', '@count deputies') + '</span></h3>')
                .append('ul')
                .attr('class', 'd3__label');

              let labelItem = labelWrapper.selectAll('li')
                .data(votingValues)
                .enter()
                .append('li')
                .attr('class', 'd3__label__item')
                .append('a')
                .html(function (d) {
                  return d;
                })
                .data(votingKeys)
                .attr('href', function (d) {
                  return pollTableUrl + '?fraction='+ fractionID + '&vote['+ d +']=' + d;
                })
                .insert('span', ':first-child')
                .attr('class', 'd3__label__item__indicator')
                .style('background-color', function (d) {
                  return Drupal.chartColorsByVote(d);
                })
                .select(function() { return this.parentNode; })
                .append('span', ':last-child')
                .html(function (d) {
                  return ' ' + Drupal.voteBehaviorLabel(d);
                });
            }
          });

          /**
           * Hide loading-animation
           */
          element.find('.ajax-progress').remove();
        });
      });
    }
  };
})(jQuery, Drupal);

/**
 * Attaches the D3 donut chart behavior.
 *
 * Applies to elements with the css-class: '.js-d3-donut'.
 * The chart can be configured by following data-attributes:
 * - [data-dataset]: The JSON-Data which contains the question/answer ratio
 *
 * e.g.: <span class="js-d3-donut" data-dataset="path-to-json/inline-json">
 *
 * @type {Drupal~behavior}
 *
 * @prop {Drupal~attachBehavior}
 */

(function ($, Drupal) {
  Drupal.behaviors.d3Donut = {
    attach: function attach(context) {
      once('d3Donut', '.js-d3-donut', context).forEach(function(currentElement) {
        let wrapper = $(currentElement)[0];
        let data = JSON.parse(wrapper.getAttribute('data-dataset'));

        let radius = 100;
        let donutWidth = radius / 10;

        // Prepare <svg> element
        let svg = d3.select(wrapper)
          .append('svg')
          .attr('viewBox', '0 0 ' + (radius * 2) + ' ' + (radius * 2))
          .attr('preserveAspectRatio', 'xMidYMid meet')
          .append('g')
          .attr('transform', 'translate(' + radius + ',' + radius + ')');

        // Calculate radius for donut segments
        let arc = d3.arc()
          .innerRadius(radius - donutWidth)
          .outerRadius(radius);

        // Calculate start and end angles for donut segments
        let pie = d3.pie()
          .value(function (d) { return d.count; })
          .sort(null);

        // Build the <path> elements for donut segements
        let path = svg.selectAll('path')
          .data(pie(data))
          .enter()
          .append('path')
          .attr('d', arc)
          .attr('fill', function (d) { return d.data.color; });
      });
    }
  };
})(jQuery, Drupal);


/**
 * Attaches the D3 donut for polls behavior.
 *
 * @type {Drupal~behavior}
 *
 * @prop {Drupal~attachBehavior}
 */

(function ($, Drupal) {
  Drupal.behaviors.d3DonutPolls = {
    attach: function (context) {
      once('d3DonutPolls', '[data-d3-donut-poll]', context).forEach(function(currentElement){
        let wrapper = $(currentElement)[0];
        let voteCounts = JSON.parse(wrapper.getAttribute('data-vote-counts'));
        let voteAccepted = wrapper.getAttribute('data-vote-accepted');
        let width = 360;
        let height = 360;
        let radius = Math.min(width, height) / 2;
        let donutWidth = 75;

        let svg = d3.select(wrapper)
          .append('svg')
          .attr('viewBox', '0 0 ' + width + ' ' + height)
          .attr('preserveAspectRatio', 'xMidYMid meet')
          .append('g')
          .attr('transform', 'translate(' + (width / 2) +
            ',' + (height / 2) + ')');

        let arc = d3.arc()
          .innerRadius(radius - donutWidth)
          .outerRadius(radius);

        let pie = d3.pie()
          .value(function (d) {
            return d.count;
          })
          .sort(null);

        svg.selectAll('path')
          .data(pie(voteCounts))
          .enter()
          .append('path')
          .attr('d', arc)
          .attr("fill", function (d) {
            return Drupal.chartColorsByVote(d.data.voting);
          });

        // Define Icon
        let iconWrapper = d3.select(wrapper)
          .append("i")
          .attr("class", "icon");
        let voteResult = '';
        if (voteAccepted == 1) {
          iconWrapper.attr("class", "aw-icon-check");
          voteResult = 'yes';
        }
        else {
          iconWrapper.attr("class", "aw-icon-times");
          voteResult = 'no';
        }

        iconWrapper.style('color', function () {
          return Drupal.chartColorsByVote(voteResult);
        });
      });
    }
  };
})(jQuery, Drupal);
